import i18n from 'Pods/Shared/I18n'

const LOCALE_LOADERS = {
  es: () => import(/* webpackChunkName: "rails-es" */ 'Translations/RailsEs'),
  ru: () => import(/* webpackChunkName: "rails-ru" */ 'Translations/RailsRu'),
  fr: () => import(/* webpackChunkName: "rails-fr" */ 'Translations/RailsFr'),
  pt: () => import(/* webpackChunkName: "rails-pt" */ 'Translations/RailsPt'),
  de: () => import(/* webpackChunkName: "rails-de" */ 'Translations/RailsDe'),
  'zh-CN': () => import(/* webpackChunkName: "rails-zh-cn" */ 'Translations/RailsZh-CN'),
  ja: () => import(/* webpackChunkName: "rails-ja" */ 'Translations/RailsJa'),
}

const pending = {}

function pageLocale() {
  return typeof document === 'undefined' ? 'en' : document.documentElement.lang
}

// Resolves once the rails translation bundle for the given locale is
// registered. English is bundled statically in Pods/Shared/I18n, so it (and
// any unknown locale, which falls back to English) resolves immediately.
//
// USAGE CONTRACT — packs must not register React components until the returned
// promise resolves, otherwise non-EN pages hydrate in English before the
// bundle arrives (English flash + React hydration mismatch). react_ujs
// auto-mounts on DOMContentLoaded as soon as it's required, so:
//   - In packs that require react_ujs inside a load/init handler, keep the
//     require("react_ujs") + useContext + mountComponents calls inside the
//     localeReady.then() callback. Registering the context any earlier lets
//     react_ujs mount before the bundle is ready.
//   - In application.jsx, react_ujs is required at module scope (so its
//     DOMContentLoaded auto-mount can't be deferred by a handler); there we
//     monkey-patch ReactRailsUJS.mountComponents to await localeReady instead.
// Either way the rule is the same: nothing mounts until this promise resolves.
function loadLocaleBundle(locale = pageLocale()) {
  const loader = LOCALE_LOADERS[locale]

  if (!loader) return Promise.resolve()

  if (!pending[locale]) {
    pending[locale] = loader().then(({ default: bundle }) => {
      i18n.addResourceBundle(locale, 'rails', bundle, true, true)
    }).catch((error) => {
      // Chunk failed to load (network blip, purged hash after a deploy):
      // resolve anyway so packs still mount with the English fallback, and
      // drop the memo so a later call can retry. Best-effort Sentry report
      // via the global set by initSentry (Utils/SentryConfig); no static
      // Sentry import so packs without Sentry don't grow.
      delete pending[locale]
      if (typeof window !== 'undefined' && typeof window.sendErrorToSentry === 'function') {
        window.sendErrorToSentry(error, { tags: { locale } })
      }
    })
  }

  return pending[locale]
}

export default loadLocaleBundle
